export const AttachProductCellRendererConstants = {
  DEFAULT_MAX_NUMBER_PRODUCTS: 5,
};
